(function(){
  function init(root){
    if(!root || root.dataset.avInit) return;
    root.dataset.avInit = '1';
    var track = root.querySelector('[data-track]');
    if(!track) return;
    var prevs = root.querySelectorAll('[data-prev]');
    var nexts = root.querySelectorAll('[data-next]');

    function firstVisibleItem(){
      var items = track.querySelectorAll('.av-cat__item');
      for(var i=0;i<items.length;i++){ if(items[i].offsetParent !== null) return items[i]; }
      return null;
    }
    function step(){
      var it = firstVisibleItem();
      if(!it) return track.clientWidth * 0.8;
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap) || 0;
      return it.getBoundingClientRect().width + gap;
    }
    function update(){
      var max = track.scrollWidth - track.clientWidth - 1;
      var atStart = track.scrollLeft <= 1;
      var atEnd = track.scrollLeft >= max;
      var noScroll = track.scrollWidth <= track.clientWidth + 2;
      root.classList.toggle('av-cat--nonav', noScroll);
      prevs.forEach(function(b){ b.disabled = atStart; });
      nexts.forEach(function(b){ b.disabled = atEnd; });
    }

    prevs.forEach(function(b){ b.addEventListener('click', function(){ track.scrollBy({left: -step(), behavior:'smooth'}); }); });
    nexts.forEach(function(b){ b.addEventListener('click', function(){ track.scrollBy({left: step(), behavior:'smooth'}); }); });

    var tabBtns = root.querySelectorAll('.av-cat__tab');
    if(tabBtns.length){
      tabBtns.forEach(function(t){
        t.addEventListener('click', function(){
          root.setAttribute('data-active-tab', t.getAttribute('data-tab'));
          tabBtns.forEach(function(x){ x.classList.toggle('is-active', x === t); });
          track.scrollLeft = 0;
          update();
        });
      });
    }

    var raf;
    function onScroll(){ if(raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }
    track.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll, {passive:true});
    if('ResizeObserver' in window){ new ResizeObserver(onScroll).observe(track); }
    update();
  }
  function boot(){ document.querySelectorAll('.av-cat[id^="av-cat-"]').forEach(init); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
